"use client";
import React from "react";

export default function ReadMore({
  text,
  threshold,
  className,
}: {
  className?: string;
  text: string;
  threshold: number;
}) {
  const [read_more, setReadMore] = React.useState(false);

  const shortened = React.useMemo(() => {
    if (text.length <= threshold) return text;
    let shortened = "";

    for (const char of text) {
      shortened += char;

      if (shortened.length >= threshold && char === ".") {
        break;
      }
    }

    return shortened;
  }, [text, threshold]);

  return (
    <p className={className}>
      {read_more ? text : shortened}
      {text.length >= threshold ? (
        <>
          <span className="ml-2" />
          <button
            className="font-bold text-foreground/40 cursor-pointer hover:text-primary text-xs transition-colors"
            onClick={() => setReadMore((prev) => !prev)}
          >
            {read_more ? "Hide" : "Read More"}
          </button>
        </>
      ) : null}
    </p>
  );
}
